'use client'

import FingerprintJS, {
  type Agent,
  type GetResult,
} from '@fingerprintjs/fingerprintjs'

let fpPromise: Promise<Agent> | null = null

export async function getFingerprint(): Promise<{
  visitorId?: string
  error?: string
}> {
  try {
    if (typeof window === 'undefined') {
      throw new Error('Fingerprint must run on client')
    }

    if (!fpPromise) {
      fpPromise = FingerprintJS.load()
    }

    const fp = await fpPromise
    const result: GetResult = await fp.get()

    return { visitorId: result.visitorId }
  } catch (error) {
    return {
      error: (error as Error).message || 'Fingerprint error',
    }
  }
}
